import { taggedTemplateLiteral as _taggedTemplateLiteral, inherits as _inherits, createClass as _createClass, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Dropdown from '../../node_modules/reactstrap/esm/Dropdown.js';
import MediaQuery from '../../_virtual/react-responsive.js';
import Avatar from './Avatar.js';
import { DropdownToggle, DropDown, MemberActions, SignedInBox, MemberName } from './pieces.js';
import MemberTypeBadge from '../MemberTypeBadge.js';
import MenuList from './MenuList.js';
import { capitalize } from '../utils/string.js';
import HeaderMailModal from '../HeaderMailModal/index.js';

var _templateObject, _templateObject2;
var AngleDown = styled.i.attrs({
  className: "fa fa-angle-down"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &.fa.fa-angle-down {\n    color: white;\n    padding: 2px 5px;\n    font-size: 16px;\n    font-weight: 600;\n  }\n"])));
var StyledDropdown = styled(Dropdown)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  height: 80px;\n  padding: 10px;\n"])));
var LoggedInUserBox = function LoggedInUserBox(_ref) {
  var me = _ref.me,
    options = _ref.options,
    comp = _ref.comp;
  return /*#__PURE__*/React__default.createElement(MemberActions, null, /*#__PURE__*/React__default.createElement(Avatar, {
    src: me && me.photo
  }), /*#__PURE__*/React__default.createElement(MediaQuery, {
    minWidth: 1200
  }, /*#__PURE__*/React__default.createElement(SignedInBox, null, /*#__PURE__*/React__default.createElement(MemberName, null, capitalize(me.firstName), /*#__PURE__*/React__default.createElement(MediaQuery, {
    minWidth: 992
  }, /*#__PURE__*/React__default.createElement(AngleDown, null))), me.type ? /*#__PURE__*/React__default.createElement(MemberTypeBadge, {
    type: me.type,
    memberClass: me["class"]
  }) : null, options ? /*#__PURE__*/React__default.createElement(MenuList, {
    options: options,
    comp: comp
  }) : null)));
};
var MemberDropdown = /*#__PURE__*/function (_React$Component) {
  function MemberDropdown(props) {
    var _this;
    _classCallCheck(this, MemberDropdown);
    _this = _callSuper(this, MemberDropdown, [props]);
    _this.state = {
      dropdownOpen: false,
      modalOpen: false,
      modalType: null
    };
    _this.toggle = _this.toggle.bind(_this);
    _this.modalToggle = _this.modalToggle.bind(_this);
    _this.setModalType = _this.setModalType.bind(_this);
    return _this;
  }
  _inherits(MemberDropdown, _React$Component);
  return _createClass(MemberDropdown, [{
    key: "toggle",
    value: function toggle() {
      this.setState(function (prevState) {
        return {
          dropdownOpen: !prevState.dropdownOpen
        };
      });
    }
  }, {
    key: "modalToggle",
    value: function modalToggle() {
      this.setState({
        modalOpen: !this.state.modalOpen
      });
    }
  }, {
    key: "setModalType",
    value: function setModalType(modalType) {
      this.setState({
        modalType: modalType
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        dropdownOpen = _this$state.dropdownOpen,
        modalOpen = _this$state.modalOpen,
        modalType = _this$state.modalType;
      var _this$props = this.props,
        me = _this$props.me,
        loading = _this$props.loading,
        options = _this$props.options,
        comp = _this$props.comp,
        _this$props$meEmailMi = _this$props.meEmailMigrationData,
        meEmailMigrationData = _this$props$meEmailMi === void 0 ? {} : _this$props$meEmailMi,
        onToggleDoNotShowAgain = _this$props.onToggleDoNotShowAgain;
      if (loading) {
        return /*#__PURE__*/React__default.createElement("p", null, "Loading");
      }
      return /*#__PURE__*/React__default.createElement(StyledDropdown, {
        isOpen: dropdownOpen,
        toggle: this.toggle,
        direction: "down"
      }, /*#__PURE__*/React__default.createElement(DropdownToggle, {
        tag: "div"
      }, /*#__PURE__*/React__default.createElement(LoggedInUserBox, {
        me: me
      })), /*#__PURE__*/React__default.createElement(HeaderMailModal, {
        open: modalOpen,
        onToggle: this.modalToggle,
        type: modalType,
        meEmailMigrationData: meEmailMigrationData,
        onToggleDoNotShowAgain: onToggleDoNotShowAgain,
        me: me
      }), /*#__PURE__*/React__default.createElement(DropDown, {
        options: options,
        comp: comp,
        modalToggle: this.modalToggle,
        meEmailMigrationData: meEmailMigrationData,
        setModalType: this.setModalType,
        me: me
      }));
    }
  }]);
}(React__default.Component);
var MobileTopMenu = function MobileTopMenu(_ref2) {
  var me = _ref2.me,
    menuOptions = _ref2.menuOptions,
    comp = _ref2.comp;
  return me ? /*#__PURE__*/React__default.createElement(LoggedInUserBox, {
    me: me,
    options: menuOptions,
    comp: comp
  }) : null;
};
MemberDropdown.propTypes = {
  me: PropTypes.object,
  loading: PropTypes.bool,
  options: PropTypes.array.isRequired,
  comp: PropTypes.func
};

export { LoggedInUserBox, MemberDropdown, MobileTopMenu, MemberDropdown as default };
